import React from 'react'
import {Hero} from '../components'
import {about} from '../utils/links'
import {Person} from '../components'
import img from '../assets/images/bosco/2.webp'
import useTitle from '../custom/useTitle'
import useDescription from '../custom/useDescription'

function AboutScreen() {
    useTitle("Chi siamo");
    useDescription("Amare la montagna significa anche viverla. Noi la amiamo, e voi?");
    return (
        <div>
            <Hero overlay>
                <hr/>
                    <div>
                        <h3>Il Team di Ceppo Trekking</h3>
                    </div>
                <hr/>
            </Hero>
            <div className="section-text">
                <div className="person-section">
                {
                    about.map(person=>{
                        return <Person key={person.name} {...person}/>
                    })
                }
                </div>
                
            </div>
            <Hero overlay img={img} height={"500px"}>
                <hr/>
                    <div>
                        <h4>Amare la montagna significa anche viverla.</h4>
                    </div>
                <hr/>
            </Hero>
            <div className="section-text">
                <h2 style={{marginLeft:"20px"}}>Vuoi Aiutarci?</h2>
                <p style={{margin:"20px"}}>Se vuoi partecipare all'organizzazione delle escursioni, contattaci alla mail:</p>
                <address style={{margin:"20px", fontSize:"larger"}}>ceppotrekking@gmail.com</address>
            </div>
        </div>
    )
}

export default AboutScreen
